import { IS_VKT_DESKTOP } from 'reactApp/appHelpers/configHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { allDocumentsLoadSuccess } from 'reactApp/modules/allDocuments/allDocuments.module';
import { initEditor } from 'reactApp/modules/editor/editor.module';
import { closePopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { isOpenPopups as isOpenPopupsSelector } from 'reactApp/modules/popup/popup.selectors';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { WorkspaceSuperAppService } from 'reactApp/services';
import { store as reduxStore } from 'reactApp/store';
import { call, take } from 'redux-saga/effects';

type CreateFileEventData = {
    type: 'CreateFile';
    data: { createFile: string };
};

const openPopUp = (event: CreateFileEventData) => {
    const state = reduxStore.getState();
    const isOpenPopups = isOpenPopupsSelector(state);
    if (isOpenPopups) {
        closePopupHelper(popupNames.CREATE_DOCUMENT);
    }
    toolbarActions.create(event.data.createFile, 'toolbar');
};

export function* watchCreateFileSubscription() {
    const shouldSubscribe = WorkspaceSuperAppService.isEnabled || IS_VKT_DESKTOP;

    if (!shouldSubscribe) {
        return;
    }

    // Ждём инициализации редакторов
    yield take(initEditor.type);

    // Ждём загрузки документов
    yield take(allDocumentsLoadSuccess.type);

    try {
        const vkTeamModule: typeof import('reactApp/modules/vkTeam/vkTeam.module') = yield call(
            () => import('reactApp/modules/vkTeam/vkTeam.module')
        );
        yield call(() => vkTeamModule.vkTeamsBridge.subscribe('CreateFile', openPopUp));
    } catch (_) {}
}
